module.exports = __webpack_public_path__ + "static/img/mp_2x.45cbeb5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mp_2x.png
// module id = HMn/
// module chunks = 1